import { render, staticRenderFns } from "./Fonte.vue?vue&type=template&id=d844563c&lang=pug"
import script from "./Fonte.vue?vue&type=script&lang=js"
export * from "./Fonte.vue?vue&type=script&lang=js"
import style0 from "./Fonte.vue?vue&type=style&index=0&id=d844563c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports